// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Alert = require("../common/Components/Alert.bs.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ProfilePhotoInput = require("../common/ProfilePicture/ProfilePhotoInput.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var MarketingProfileMemberPhotoFormMutation_graphql = require("../../__generated__/MarketingProfileMemberPhotoFormMutation_graphql.bs.js");
var AvatarDefaultSvg = require("../../../assets/images/elements/avatar-default.svg");
var MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql = require("../../__generated__/MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql.bs.js");
var MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql = require("../../__generated__/MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql.bs.js");
var MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql = require("../../__generated__/MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql.bs.js");

var convertFragment = MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var avatarPlaceholder = AvatarDefaultSvg;

function MarketingProfileMemberPhotoForm$CurrentPhoto(props) {
  var member = use(props.member);
  var profilePicture = member.profilePicture;
  var src = profilePicture !== undefined ? profilePicture.url : avatarPlaceholder;
  var match = member.profilePicture;
  var alt = match !== undefined ? "Your current profile picture" : "Placeholder profile picture showing a person's silhouette";
  return JsxRuntime.jsx("img", {
              className: "w-24 h-24 rounded-full",
              alt: alt,
              src: src
            });
}

var CurrentPhoto = {
  Fragment: Fragment,
  avatarPlaceholder: avatarPlaceholder,
  make: MarketingProfileMemberPhotoForm$CurrentPhoto
};

var convertFragment$1 = MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

var Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var convertVariables = MarketingProfileMemberPhotoFormMutation_graphql.Internal.convertVariables;

var convertResponse = MarketingProfileMemberPhotoFormMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = MarketingProfileMemberPhotoFormMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MarketingProfileMemberPhotoFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables, MarketingProfileMemberPhotoFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

var Mutation_imageContentType_decode = MarketingProfileMemberPhotoFormMutation_graphql.Utils.imageContentType_decode;

var Mutation_imageContentType_fromString = MarketingProfileMemberPhotoFormMutation_graphql.Utils.imageContentType_fromString;

var Mutation = {
  imageContentType_decode: Mutation_imageContentType_decode,
  imageContentType_fromString: Mutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

function MarketingProfileMemberPhotoForm$ChangeProfilePhoto(props) {
  var onNewPhotoSaved = props.onNewPhotoSaved;
  var member = use$1(props.member);
  var match = use$2();
  var mutate = match[0];
  var match$1 = member.profilePicture;
  var buttonText = match$1 !== undefined ? "Change photo" : "Add photo";
  return JsxRuntime.jsx(ProfilePhotoInput.make, {
              onSubmit: (function (param, param$1) {
                  var notifyOnError = param$1.notifyOnError;
                  var notifyOnSuccess = param$1.notifyOnSuccess;
                  mutate({
                        input: {
                          memberId: member.id,
                          profilePhoto: {
                            croppedPhoto: param.croppedPhoto,
                            originalPhoto: param.originalPhoto
                          }
                        }
                      }, undefined, undefined, undefined, (function (_response, errors) {
                          if (errors !== undefined) {
                            return notifyOnError("There was an error saving your photo. Please try again.");
                          } else {
                            notifyOnSuccess();
                            return onNewPhotoSaved();
                          }
                        }), (function (param) {
                          notifyOnError("There was an error saving your photo. Please try again.");
                        }), undefined);
                }),
              onPhotoSelected: props.onNewPhotoSelected,
              buttonText: buttonText
            });
}

var ChangeProfilePhoto = {
  Fragment: Fragment$1,
  Mutation: Mutation,
  make: MarketingProfileMemberPhotoForm$ChangeProfilePhoto
};

var convertFragment$2 = MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

var Fragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MarketingProfileMemberPhotoForm$WithoutErrorBundary(props) {
  var member = use$3(props.member);
  var match = React.useState(function () {
        return "InitialState";
      });
  var setState = match[1];
  var tmp;
  tmp = match[0] === "InitialState" ? null : JsxRuntime.jsx(Alert.Success.make, {
          title: Core__Option.getOr(member.firstName, member.displayName) + "'s photo was updated"
        });
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(MarketingProfileMemberPhotoForm$CurrentPhoto, {
                              member: member.fragmentRefs
                            }),
                        JsxRuntime.jsx(MarketingProfileMemberPhotoForm$ChangeProfilePhoto, {
                              member: member.fragmentRefs,
                              onNewPhotoSaved: (function () {
                                  setState(function (param) {
                                        return "Success";
                                      });
                                }),
                              onNewPhotoSelected: (function () {
                                  setState(function (param) {
                                        return "InitialState";
                                      });
                                })
                            })
                      ],
                      className: "mt-2 sm:mt-0 flex gap-6 items-center md:flex-col lg:flex-row"
                    }),
                JsxRuntime.jsx("div", {
                      children: tmp,
                      className: "flex"
                    })
              ],
              className: "sm:py-6 space-y-4"
            });
}

var WithoutErrorBundary = {
  make: MarketingProfileMemberPhotoForm$WithoutErrorBundary
};

function MarketingProfileMemberPhotoForm(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "Profile photo",
              children: JsxRuntime.jsx(MarketingProfileMemberPhotoForm$WithoutErrorBundary, {
                    member: props.member
                  })
            });
}

var make = MarketingProfileMemberPhotoForm;

exports.CurrentPhoto = CurrentPhoto;
exports.ChangeProfilePhoto = ChangeProfilePhoto;
exports.Fragment = Fragment$2;
exports.WithoutErrorBundary = WithoutErrorBundary;
exports.make = make;
/* avatarPlaceholder Not a pure module */
